import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-slate-800 via-slate-900 to-black text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div>
            <img
              src="https://static.readdy.ai/image/b0020c9f1a780c0942b742aa130ad404/0dc6ea23744c128b2d88864a39c6bd14.jpeg"
              alt="YESJETS Logo"
              className="h-16 w-auto object-contain mb-4"
            />
            <p className="text-slate-400 text-sm leading-relaxed">
              YESJETS LLC ACTS ON BEHALF OF ITS CLIENTS AND SERVES AS THEIR AGENT. IT DOES NOT OWN OR OPERATE AIRCRAFT; ALL CHARTER FLIGHTS ARE FULLY OPERATED BY FAA CERTIFIED 135 AIR CARRIERS AND ARE REQUIRED TO ADHERE TO SAFETY REQUIREMENTS.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-gold font-sans text-sm tracking-widest mb-4">QUICK LINKS</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-300 hover:text-gold transition-colors text-sm cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/planes" className="text-slate-300 hover:text-gold transition-colors text-sm cursor-pointer">
                  Fleet
                </Link>
              </li>
              <li>
                <Link to="/destinations" className="text-slate-300 hover:text-gold transition-colors text-sm cursor-pointer">
                  Destinations
                </Link>
              </li>
              <li>
                <Link to="/why-yesjets" className="text-slate-300 hover:text-gold transition-colors text-sm cursor-pointer">
                  Why YESJETS
                </Link>
              </li>
              <li>
                <Link to="/time-value" className="text-slate-300 hover:text-gold transition-colors text-sm cursor-pointer">
                  Time Value
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-gold font-sans text-sm tracking-widest mb-4">COMPANY</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-slate-300 hover:text-gold transition-colors text-sm cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-300 hover:text-gold transition-colors text-sm cursor-pointer">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-slate-300 hover:text-gold transition-colors text-sm cursor-pointer">
                  Book a Flight
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-gold font-sans text-sm tracking-widest mb-4">CONTACT</h3>
            <ul className="space-y-3 text-sm text-slate-300">
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-gold mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                <span>+1 708-567-8866</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-gold mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                <span>Michael@flyyesjets.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-gold mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                <span>Chicago, Illinois</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-400 text-sm">
            © {currentYear} YESJETS. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-slate-400 hover:text-gold transition-colors cursor-pointer">
              <i className="ri-facebook-fill text-xl w-6 h-6 flex items-center justify-center"></i>
            </a>
            <a href="#" className="text-slate-400 hover:text-gold transition-colors cursor-pointer">
              <i className="ri-instagram-line text-xl w-6 h-6 flex items-center justify-center"></i>
            </a>
            <a href="#" className="text-slate-400 hover:text-gold transition-colors cursor-pointer">
              <i className="ri-linkedin-fill text-xl w-6 h-6 flex items-center justify-center"></i>
            </a>
            <a href="#" className="text-slate-400 hover:text-gold transition-colors cursor-pointer">
              <i className="ri-twitter-x-line text-xl w-6 h-6 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}